import { useUserEventLogger } from '@repo/tracking-service';
import { LottiePlayer } from '@repo/ui';
import { BottomDrawer, Button, Description, List } from '@zenterprise-inc/ui';
import { useEffect } from 'react';

import { ModalProps } from '@/lib/constants/summary';

export const RuralSpecialTaxNoPayModal = ({ isOpen, onClose }: ModalProps) => {
  const { sendViewEvent } = useUserEventLogger();

  useEffect(() => {
    if (isOpen) {
      sendViewEvent('home_modal_rural-not-required');
    }
  }, [isOpen, sendViewEvent]);

  return (
    <BottomDrawer.Basic isVisible={isOpen} onCloseDrawer={onClose} backDropClose={false}>
      <BottomDrawer.Basic.Header isCloseButton onCloseDrawer={onClose}>
        농어촌특별세 고지서를 받으셨나요?
      </BottomDrawer.Basic.Header>
      <BottomDrawer.Basic.Contents isBottomButton>
        <Description.Guide
          imgChild={
            <div className={'h-20 w-20'}>
              <LottiePlayer src={'/lotties/summary/ani_envelope-check.json'} />
            </div>
          }
          subTitle={'따로 납부하실 필요 없어요'}
          description={'농어촌특별세는 입금될 환급금에서 자동 납부되어 납부 금액을 제외하고 입금될 거예요.'}
        />
      </BottomDrawer.Basic.Contents>
      <BottomDrawer.Basic.BottomButton>
        <Button.StickyBottom.Button className="w-full" state="primary" onClick={onClose}>
          확인
        </Button.StickyBottom.Button>
      </BottomDrawer.Basic.BottomButton>
    </BottomDrawer.Basic>
  );
};

export const RuralSpecialTaxPayModal = ({ isOpen, onClose }: ModalProps) => {
  const { sendViewEvent } = useUserEventLogger();

  useEffect(() => {
    if (isOpen) {
      sendViewEvent('home_modal_rural-required');
    }
  }, [isOpen, sendViewEvent]);

  return (
    <BottomDrawer.Basic isVisible={isOpen} onCloseDrawer={onClose} backDropClose={false}>
      <BottomDrawer.Basic.Header isCloseButton onCloseDrawer={onClose}>
        농어촌특별세 고지서를
        <br />
        받으셨다면 납부가 필요해요
      </BottomDrawer.Basic.Header>
      <BottomDrawer.Basic.Contents isBottomButton>
        <div className={'px-6'}>
          <List.Basic
            left={<img src="/images/illus-icons/fill-papers-tax-check-rg.svg" alt="papers tax check icon" />}
            title={{ text: '안정적으로 환급 완료됐다는 의미에요', titleStyle: 'font-bold' }}
            subText={{ text: '환급금을 많이 받기 위해 진행한 절차에서 추가로 농어촌특별세가 부과됐어요.' }}
          />
          <List.Basic
            left={<img src="/images/illus-icons/fill-account-right-rg.svg" alt="account right icon" />}
            title={{ text: '곧 환급금이 입금될 예정이에요', titleStyle: 'font-bold' }}
            subText={{ text: '빠른 시일 안에 농어촌특별세보다 더 많은 환급금이 입금되니 먼저 납부해도 괜찮아요.' }}
          />
          <List.Basic
            left={<img src="/images/illus-icons/fill-c-minus-rg.svg" alt="papers tax check icon" />}
            title={{ text: '납부 비용은 이용료에서 제외돼요', titleStyle: 'font-bold' }}
            subText={{ text: '결제하실 이용료에서 농어촌특별세 납부 비용은 제외해서 안내해드려요.' }}
          />
        </div>
      </BottomDrawer.Basic.Contents>
      <BottomDrawer.Basic.BottomButton>
        <Button.StickyBottom.Button className="w-full" state="primary" onClick={onClose}>
          확인
        </Button.StickyBottom.Button>
      </BottomDrawer.Basic.BottomButton>
    </BottomDrawer.Basic>
  );
};
